let input = document.querySelector('input[name="shipping_addr"]');
if (input) {
    let country_code = input.getAttribute('data-country');
    let autocomplete = new google.maps.places.Autocomplete(input,
        {
            types: ['(regions)'],
            componentRestrictions: {
                country: country_code
            }
        }
    );
    google.maps.event.addListener(autocomplete, 'place_changed', function () {
        let result = autocomplete.getPlace();
        if (!result || !result.address_components || result.address_components.length === 0) return;

        const postcode = result.address_components.find((item) => item.types.includes("postal_code"))?.short_name;
        const state = result.address_components.find((item) => item.types.includes("administrative_area_level_1"))?.short_name;
        let destination = { country: country_code.toUpperCase(), province: state, postal_code: postcode };

        if (!postcode || !state) return;

        const rateRequest = {
            destination,
            lineItems: [
                {
                    quantity: 1,
                    name: product_obj.title,
                    sku: product_obj.sku,
                    grams: product_obj.weight*1,
                    price: product_obj.price*1,
                    vendor: product_obj.vendor,
                    requires_shipping: true,
                    properties: null,
                    product_id: product_obj.id,
                    variant_id: product_obj.variant,
                },
            ],
        };

        fetch("/tools/etoile-integration/shopify/carrier-service/calculate", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "x-shopify-shop-domain": window.Shopify.shop
            },
            body: JSON.stringify({ skipCache: true, rateRequest }),
            })
            .then((response) => response.json())
            .then((response) => {
                let res = getRateContext(response.rateContext);
                let res_block = document.querySelector('.shipping-check .result');
                if (res.status === 'unavailable') {
                    res_block.classList.add('grey-dark');
                    res_block.classList.remove('green-light');
                } else {
                    res_block.classList.add('green-light');
                    res_block.classList.remove('grey-dark');
                }
                res_block.innerHTML = res.message;
            });
    });

    function getRateContext(rateContext) {
        if (!rateContext) return null;
        console.log('Delivery');
        console.log(rateContext);
        let deliveryMessage = 'Same-Day Delivery';

        const hasSameDayAvailable = rateContext.rates.find((rate) => rate.shopifyDefinition.service_code.startsWith("LOCAL_SAME_DAY"));
        if (hasSameDayAvailable) return { message: "Hooray! Order before 2pm for same-day delivery.", status: "available" };

        const rejectedSameDayReason = rateContext.rejectedRates.find((rate) => rate.code.startsWith("LOCAL_SAME_DAY"))?.reasonRejected;
        if (rejectedSameDayReason) {
            if (rejectedSameDayReason === "Same day shipping unavailable for orders made after 2pm") {
                return {
                    message:
                        "Oh no! Whilst your postcode qualifies, our same day delivery service stops at 2pm. Shipping is still fast - select a suitable date at checkout.",
                    status: "unavailable",
                };
            }

            if (rejectedSameDayReason === "Local rates unavailable outside of warehoused metro areas") {
                return {
                    message: `Sorry! You're outside of the ${
                        deliveryMessage.includes("4-Hour") ? "4-Hr" : "Same-Day"
                    } delivery zone. Don't worry, order before 2pm and we'll dispatch same day. Shipping is still fast!`,
                    status: "unavailable",
                };
            }

            if (rejectedSameDayReason === "Local rates unavailable as item(s) being shipped from Sydney warehouse") {
                return {
                    message:
                        "Oh no! Whilst your suburb qualifies for same-day delivery, this item is being shipped from our Sydney warehouse. Shipping is still fast!",
                    status: "unavailable",
                };
            }

            if (rejectedSameDayReason === "Local rates unavailable as item(s) being shipped from Melbourne warehouse") {
                return {
                    message:
                        "Oh no! Whilst your suburb qualifies for same-day delivery, this item is being shipped from our Melbourne warehouse. Shipping is still fast!",
                    status: "unavailable",
                };
            }

            return { message: rejectedSameDayReason, status: "unavailable" };
        }

        return {
            message:
                "Unable to calculate Shipping Rates for your postcode. Please proceed to the checkout to see all available shipping options.",
            status: "unavailable",
        };
    }
}